<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";

let componentStatisticConfig = {
    cId: "componentStatistic",
    cType: "componentStatistic",
    cTitle: "Component Statistics",
    showInCmpList: false,
    cTemplate: `<div v-if="component" class="component-statistic">
                    <div class="col-md-12 col-sm-12 filter">
                        <div class="col-md-5 col-sm-12">
                            <condensed-filter :prop-filter-options="filterOptions" :prop-filter-items="statistic" cId="condensedFilter__statistic" :component-store-id="storeId"></condensed-filter>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                    <!--<div class="col-md-12 col-sm-12">
                        <chart cId="chart_statistic" :config="chartConfig" :prop-series-data="chartStatistic" :prop-ignore-dataset="true"></chart>
                    </div>-->
                    <div class="col-md-12 col-sm-12">
                        <grid cId="grid_cmpstatistic" :prop-data="filteredItems"></grid>
                    </div>
                </div>`
};

let componentStatisticCmp = {
    name: 'componentStatistic',
    props: {
        componentId: {
            default: false
        },
    },
    data() {
        return {
            component: null,
            statistic: {},
            chartStatistic: {},
            chartConfig: {},
            filteredItems: {},
            filterOptions: {
                last_load: {
                    label: 'Last Used',
                },
                instance: {
                    label: 'Instance',
                },
                projectName: {
                    label: 'Project Name',
                },
                accountId: {
                    label: 'Account ID',
                },
                recruiterId: {
                    label: 'Recruiter ID',
                }
            }
        };
    },
    components: {
        chart: defineAsyncComponent(() => import('@common/chart/chart.vue')),
        grid: defineAsyncComponent(() => import('@common/grid/grid.vue'))
    },
    methods: {
        async onLoad() {
            if (this.componentId) {
                this.component = await componentStore.getConfig(this.componentId);
            }
            this.onPropsUpdate(false);
        },
        async onPropsUpdate() {
            await this.initStatistic();
        },
        onUpdate() {
            this.updateStatistic();
        },
        async initStatistic() {
            if (this.component) {
                this.statistic = await componentStore.getStatistics(this.componentId);
                this.updateStatistic();
            }
        },
        async updateStatistic() {
            let statistic = {};
            let filteredStatistics = this.filteredItems;
            if (filteredStatistics) {
                for (let i in filteredStatistics) {
                    if (i === 'length') continue;
                    statistic[filteredStatistics[i].date] = filteredStatistics[i].count_loads;
                }
            }
            this.chartStatistic = statistic;
        }
    }
};

componentStore.initComponent(componentStatisticCmp, componentStatisticConfig);
export { componentStatisticConfig, componentStatisticCmp };
export default componentStatisticCmp;
</script>

<style>
    .component-statistic .fr {
        float: right;
    }

    .component-statistic .filter[class^="col-"], .component-statistic .filter div[class^="col-"] {
        margin: 0;
        padding: 0;
    }

    .component-statistic .filter > div[class^="col-"] {
        margin: 0 auto;
    }

    .component-statistic #container_svg {
        overflow: visible;
    }
</style>
